import { z } from 'zod';

import { entityIdentifierSchema } from './chat-entity';
import { chatEventIdSchema, chatMessageIdSchema, chatThreadIdSchema } from './chat-ids';

export const contextRefreshActionSchema = z.enum(['archived', 'created', 'deleted', 'unarchived', 'updated']);

export type ContextRefreshAction = z.infer<typeof contextRefreshActionSchema>;

export const contextRefreshPayloadSchema = z.object({
    action: contextRefreshActionSchema,
    entities: z.array(entityIdentifierSchema).min(1),
});

export type ContextRefreshPayload = z.infer<typeof contextRefreshPayloadSchema>;

export const contextRefreshEventSchema = z.object({
    eventId: chatEventIdSchema,
    eventType: z.literal('context-refresh'),
    messageId: chatMessageIdSchema,
    payload: contextRefreshPayloadSchema,
    threadId: chatThreadIdSchema,
    timestamp: z.string(),
});

export type ContextRefreshEvent = z.infer<typeof contextRefreshEventSchema>;
